import type { FC } from 'react'

import { Trans } from 'react-i18next'

import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { Button } from '../../Button/Button'
import { ContentUnavailable } from '../../ContentUnavailable/ContentUnavailable'
import { ContentUnavailableWrapper } from '../styles'

type FallbackContentProps = {
  translationKey: string
  onButtonClick?: () => void
  tournamentName?: string
}

export const MatchesFallback: FC<FallbackContentProps> = ({
  translationKey,
  onButtonClick,
  tournamentName,
}) => {
  const { t } = useCommonTranslation()

  const buttonText = t(`soccerData.matches.${translationKey}.button`)
  const i18KeyInfo = `soccerData.matches.${translationKey}.text`

  return (
    <ContentUnavailableWrapper>
      <ContentUnavailable>
        <Trans
          i18nKey={i18KeyInfo}
          values={{ name: tournamentName }}
          shouldUnescape
        />
        {onButtonClick && <Button onClick={onButtonClick} text={buttonText} />}
      </ContentUnavailable>
    </ContentUnavailableWrapper>
  )
}
